import React, { useEffect } from 'react'
import AuthNavbar from '../Components/AuthNavbar/AuthNavbar'
import { Container } from 'react-bootstrap'
import CustomHeader from '../Components/CustomHeader/CustomHeader'
import CustomForm from '../Components/CustomForm/CustomForm'
import {  fetchRestaurant, updateRestaurant } from '../hooks/resturant'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { fetchStudent, updateStudent} from '../hooks/students'

function EditStudent() {
const dispatch = useDispatch();
const navigate = useNavigate();
const {id}=useParams();  
const { list } = useSelector((state) => state.resturants);
const {singleStudent:studentData}=useSelector((state)=>state.students)
console.log(studentData);

useEffect(() => {
dispatch(fetchStudent(id))
}, [])

    const infoData = [
  {
    id: 0,
    title: "معلومات أساسية",
      inputs: [
        { id: "name", title: "الاسم", type: "text" },
        { id: "username", title: "اسم المستخدم", type: "text" },
        { id: "password", title: "كلمة المرور", type: "text" },
        { id: "password_confirmation", title: "تأكيد كلمة المرور", type: "text" },
        { id: "military_number", title: "الرقم العسكري", type: "text" },
        { id: "rank", title: "الرتبة", type: "text" },
        { id: "workplace", title: "جهة العمل", type: "text" },
        {
          id: "restaurant_id",
          title: "اختار المطعم",
          type: "select",
          options:list,
        },

      ],
  },
];

const handleSubmit = (formData) => {
  console.log(formData);
  
  // formData will usually be an object like { name: "Restaurant Name" }
  dispatch(updateStudent(formData))
    .unwrap() // Allows us to use .then() / .catch() on the thunk result
    .then(() => {
      alert("تم تعديل المستفيد بنجاح");
      navigate('/dashboard/students'); // Redirect to list page
    })
    .catch((err) => {
      // Error is already handled in Redux, but you can do specific UI logic here
      console.error("Failed to save:", err);
    });
};
return (
  <div>
      <AuthNavbar/>
        <Container>
                  <CustomHeader
        title={"تعديل مطعم "}
        subtitle={""}
        downloadData={false}
      />
      <CustomForm
formStructure={infoData}
image={false}
onSubmit={handleSubmit}
initialData={studentData}

      />
          </Container>
          </div>
)
}

export default EditStudent
